import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  studentList: [],
}

export const getters = {}

export const mutations = {
  CACHE_STUDENT_LIST(state, newList) {
    state.studentList = newList
  },
}

export const actions = {
  fetchStudentList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/studentdetail?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_STUDENT_LIST', list)
        return list
      })
  },
  addStudent({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/studentdetail`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  addStudentInBulk({ commit, state, rootState }, { Data }) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/studentdetail/studentData`,
        Data
      )
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
